import {
  SETTINGS_FETCH,
  SETTINGS_FETCH_FAIL,
  SETTINGS_FETCH_SUCCESS,
  SETTINGS_SAVE,
  SETTINGS_SAVE_FAIL,
  SETTINGS_SAVE_SUCCESS
} from '../actions/settings';
const initialState = {
  loading: false,
  saving: false,
  formValues: null,
  model: null
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case SETTINGS_FETCH:
      return Object.assign({}, state, {
        loading: true,
        model: null,
        formValues: null
      });

    case SETTINGS_FETCH_FAIL:
      return Object.assign({}, state, {
        loading: false
      });

    case SETTINGS_FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        model: action.settings,
        formValues: prepareInitialValue(action.settings)
      });

    case SETTINGS_SAVE:
      return Object.assign({}, state, {
        saving: true
      });

    case SETTINGS_SAVE_FAIL:
      return Object.assign({}, state, {
        saving: false
      });

    case SETTINGS_SAVE_SUCCESS:
      return Object.assign({}, state, {
        saving: false
      });

    default:
      return state;
  }
}

function prepareInitialValue(model) {
  let { terms_and_conditions, data_security } = model;

  return { terms_and_conditions, data_security };
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js